import { useQuery, gql } from '@apollo/client'

//TODO cleanup, many of these are not needed
const WORKOUT_CATEGORIES = gql`
  {
    workoutTemplateCategory(queryArgs: { page: 1, size: 1000 }) {
      id
      name
      rank
      requiresSpecialWorkoutAccess
      templates {
        id
        name
        description
        workoutType
        duration
        rank
        image {
          downloadLocation
        }
        variants {
          difficultyLevel
          id
          rounds {
            countdownSeconds
            breakSeconds
            videoUrl
            exercises {
              videoUrl
              seconds
              breakSeconds
            }
          }
        }
      }
    }
  }
`

export const useWorkoutCategoriesQuery = () => useQuery(WORKOUT_CATEGORIES)
